import { DefaultTheme } from "styled-components";

const theme: DefaultTheme = {
  breakpoints: {
    xs: "(max-width: 400px)",
    sm: "(max-width: 600px)",
    md: "(max-width: 900px)",
    lg: "(max-width: 1280px)",
    xl: "(max-width: 1440px)",
    xxl: "(max-width: 1920px)",
  },
  colors: {
    primary: "#1976d2",
    secondary: "#575757",
    background: "#000000",
    border: "#EAEAEA",
    white: "#FFFFFF",
    black: "#0A0A0A",
    blackLight: "#191919",
    buttonbackground: "#8940FF",
    errorRed: "#F8274B",
    red: "#EE1D24",
    activePrimary: "#19E439",
    activegreen: "#0AB625",
    yellow: "#FFD84F",
    inActivePrimary: "rgba(163, 163, 163, 1)",
    blackGrey: "#212121",
    text: "#FFFFFF",
    textSecondary: "#A5A5A5",
    textLightGrey: "#A7A7A7",
    carouselSecondary: "#CECECE",
    secondaryWhite: "#FAFAFA",
    textColor:"rgba(64, 64, 64, 1)",
    textPrimaryColor: "#8940FF",
    textLightDark:"rgba(10, 10, 10, 1)",
    borderColor:"rgba(64, 64, 64, 0.12)",
    hoverButtonColor: "#39058d",
    transparentTeal: "#00E5D9",
    secondaryErrorState: "#FF3535",
    grey: {
      100: "#F9FAFB",
      200: "#F4F6F8",
      300: "#DFE3E8",
      400: "#C4CDD5",
      500: "#919EAB",
      600: "#637381",
      700: "#454F5B",
      800: "#212B36",
      900: "#161C24",
      1000: "#ADADAD",
      1100: "#C6C6C6",
      1200: "#A3A3A3",
      1300: "#a0a0a0",
      1400: "#B7B7B7",
      1500: "#E5E5E5",
      1600: "#404040",
      1700: "#D9D9D9",
    },
    gradientPrimary:
      "transparent radial-gradient(closest-side at 60% 17%, #00000000 0%, #000000 100%) 0% 0% no-repeat padding-box",
    gradientPrimaryMenu:
      "transparent linear-gradient(90deg, #000000 0%, #10101000 100%) 0% 0% no-repeat padding-box",
    primaryMenu: "#ADADAD",
    primaryBgMenu: "#212121",
    primaryBgMenuBorder: "#707070",
    secondaryUpnext: "#7C7C7C",
    secondaryState: "#F37F13",
  },
  shadows: {
    shadowsPrimaryMenu: "0px 3px 6px #00000029",
  },
  shape: {
    borderRadius: 4,
    cardBorderRadius: 10,
  },
  spacing: (factor: number) => `${4 * factor}px`,
  containerSpacing: "74px",
  typography: {
    font12: "12px",
    font13: "13px",
    font14: "14px",
    font16: "16px",
    font18: "18px",
    font22: "22px",
    font24: "24px",
    font28: "28px",
    font30: "30px",
    font36: "36px",
    font40: "40px",
    font48: "48px",
    font64: "64px",
    font46: "46px",
    font50: "50px",
    font56: "56px",
    font80: "80px",
    fontFamily: "'Roboto', sans-serif",
    fontWeightLight: 300,
    fontWeightRegular: 400,
    fontWeightMedium: 500,
    fontWeightBold: 700,
    fontWeightBolder: 900,
    leading17: "17px",
    leading18: "18px",
    leading25: "25px",
    leading26: "26px",
    leading27: "27px",
    leading28: "28px",
    leading30: "30px",
    leading32: "32px",
    leading34: "34px",
    leading60: "60px",
    leading65: "65px",
    leading74: "74px",
    leading77: "77px",
    h1: {
      fontWeight: 900,
      lineHeight: "77px",
      fontSize: "80px",
    },
    h2: {
      fontWeight: 700,
      lineHeight: "60px",
      fontSize: "56px",
    },
    h3: {
      fontWeight: 700,
      lineHeight: "30px",
      fontSize: "50px",
    },
    h4: {
      fontWeight: 700,
      lineHeight: "34px",
      fontSize: "46px",
    },
    h5: {
      fontWeight: 500,
      lineHeight: "60px",
      fontSize: "36px",
    },
    h6: {
      fontWeight: 500,
      lineHeight: "60px",
      fontSize: "30px",
    },
  },
};

export default theme;
